<template>
    <div class="admin_permission_wrap">
        <div class="admin_permission_top">
            <div class="admin_permission_tab">
                <ul>
                    <li @click="handleClickTab(item)"  :class="item.name == activeName ? 'active' : ''"   v-for="item in tabList"   v-text="item.label"></li>
                </ul>
            </div>
        </div>
        <div class="admin_permission_bottom">
            <template v-if="activeName == '1'">
                <div class="admin_permission_child_wrap">
                    <div class="admin_permission_child_top">
                        <div class="prompt">主管理员可以添加子管理员，拥有客户管理全部功能权限</div>
                        <el-button size="small" type="primary" @click="handleClickAddModule">添加管理员</el-button>
                    </div>
                    <div class="admin_permission_child_table">
                        <CustomVxeTable
                                v-if="activeName == '1'"
                                key="tableRef"
                                ref="tableRef"
                                class="custom-table"
                                id="modulePermissionTable"
                                :tableData="tableDataAdmin"
                                :reduceHeight="reduceHeight"
                                :isShowToolBar="true"
                                :loading="loading"
                                :empty-render="{ name: 'NotData' }"
                                :pagination.sync="pagination"
                                @handleCurrentChange="handleCurrentChange"
                                @handleSizeChange="handleSizeChange"
                                :customConfig="tableCustomConfig">
                            <vxe-column field="user" title="管理员"  min-width="200" show-overflow>
                                <template #default="{ row }">
                                    <userDetailPopover v-if="row.user">
                                        <div slot="container">
                                            <div class="custome_user_head ellipsis" >
                                                <img :src="row.user.avatar ? row.user.avatar : defaultImg" alt="">
                                                <span v-text="row.user.name"></span>
                                            </div>
                                        </div>
                                    </userDetailPopover>
                                    <el-tooltip v-if="row.type == 0"  class="item" effect="dark" content="主管理员" placement="top-start">
                                       <span class="handle_icon_wrap">
                                            <i style="color: rgba(240, 170, 50, 1);" class="iconfont icon-bumenfuzeren1"></i>
                                       </span>
                                    </el-tooltip>

                                </template>
                            </vxe-column>
                            <vxe-column field="department_name" title="部门"  min-width="200" show-overflow>
                                <template #default="{ row }">
                                    <span v-if="row.user" v-text="row.user.department_name"></span>
                                </template>
                            </vxe-column>
                            <vxe-column field="created_at" title="最近编辑授权时间"  min-width="200" show-overflow></vxe-column>
                            <vxe-column field="handle" title="操作" align="center" width="60" show-overflow>
                                <template #default="{ row }">
                                    <el-button v-if="row.type == 0" :disabled="(is_company_admin || is_system_sub_admin) ? false  : true" type="text" @click="handleClickModuleDel(row)" class="danger_text">移除</el-button>
                                    <el-button v-if="row.type == 1" type="text" @click="handleClickModuleDel(row)" class="danger_text">移除</el-button>
                                </template>
                            </vxe-column>
                            <template #empty>
                                <div class="custom-table-empty">
                                    <div class="custom-table-empty-img">
                                        <img src="https://download.hecoos.com/enlightv/2025-09/79aca5659d09f1a8f1161d7106c3ecf6.png" alt="">
                                    </div>
                                    <p class="custom-table-empty-txt" >暂无数据</p>
                                </div>
                            </template>
                        </CustomVxeTable>


                    </div>
                </div>

            </template>

            <template v-if="activeName == '2'">
                <div class="admin_permission_child_wrap">
                    <div class="admin_permission_child_top">
                        <div >
                            <el-input size="small" v-model="keywords" placeholder="请输入姓名/权限内容"  clearable  @clear="handleClickSearch"  @keyup.enter.native="handleClickSearch">
                                <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                            </el-input>
                        </div>
                        <el-button size="small" type="primary" @click="handleClickAddAuth">新增权限</el-button>
                    </div>
                    <div class="admin_permission_child_table">
                        <CustomVxeTable
                                v-if="activeName == '2'"
                                key="tableRef1"
                                ref="tableRef1"
                                class="custom-table"
                                id="moduleUserPermissionTable"
                                :tableData="tableData"
                                :reduceHeight="reduceHeight"
                                :isShowToolBar="true"
                                :loading="loading"
                                :empty-render="{ name: 'NotData' }"
                                :pagination.sync="pagination"
                                @handleCurrentChange="handleCurrentChange"
                                @handleSizeChange="handleSizeChange"
                                :customConfig="tableCustomConfig">
                            <vxe-column field="relation_names" title="授权人员"  min-width="200" show-overflow>
                                <template #default="{ row }">
                                    <span v-if="row.relation_names" v-text="row.relation_names.join(',')"></span>
                                </template>
                            </vxe-column>
                            <vxe-column field="relation_count" title="授权人数(人)" header-align="right" align="right" width="110" show-overflow></vxe-column>
                            <vxe-column field="permission_names" title="权限范围"  min-width="200" show-overflow>
                                <template #default="{ row }">
                                    <el-tag style="margin-right: 5px" type="info" size="small" v-for="item in row.permission_names" v-text="item"></el-tag>
                                </template>
                            </vxe-column>
                            <vxe-column field="handle" title="操作" align="center" width="160" show-overflow>
                                <template #default="{ row }">
                                    <el-button type="text" @click="handleClickAuth(row)">授权</el-button>
                                    <span class="line"></span>
                                    <el-button type="text" @click="handleClickEditAuth(row)">编辑</el-button>
                                    <span class="line"></span>
                                    <el-button type="text" @click="handleClickDelAuth(row)" class="danger_text">删除</el-button>
                                </template>
                            </vxe-column>
                            <template #empty>
                                <div class="custom-table-empty">
                                    <div class="custom-table-empty-img"></div>
                                    <p class="custom-table-empty-txt" >暂无数据</p>
                                </div>
                            </template>
                        </CustomVxeTable>


                    </div>
                </div>


            </template>
        </div>
        <AddModuleAdmin :addModuleDialog.sync="addModuleDialog" :ticketId="addModuleDialog" :moduleAdminUser="moduleAdminUser" :moduleName="moduleName" @success="getTableData" v-if="addModuleDialog" />

        <AuthorizedOperator :authorizedOperatorVisible.sync="authorizedOperatorVisible" :roleId="roleId" :moduleName="moduleName" v-if="authorizedOperatorVisible" @success="handleClickSearch" />
        <userDepartmentPostSelection :userDepartmentPostVisible.sync="userDepartmentPostVisible" v-if="userDepartmentPostVisible" :userDepartmentPostSelected="userDepartmentPostSelected" :selectType="'departmentUserTag'" :userDepartmentPostTitle="'授权人员'"  @success="userDepartmentPostSuccess"/>

    </div>
</template>
<script>
import {mapState} from "vuex";
import userDetailPopover from "@/components/pComponents/userDetailPopover";
import {getSubModuleAdmins, deleteSubModuleAdmin,deleteModuleAdmin,getVirtualRoleListByModel,deleteVirtualRole,updateUserPermissions} from "@/api/index.js"
import {pagination} from "@/mixins";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import AddModuleAdmin from  "./component/add_module_admin"
import AuthorizedOperator from "./component/authorized_operator.vue";
import userDepartmentPostSelection from "@/components/pComponents/userDepartmentPostSelection.vue";

export default {
    name: "ModulePermission",
    components: {
       userDetailPopover,
        CustomVxeTable,
        AddModuleAdmin,
        AuthorizedOperator,
        userDepartmentPostSelection
    },
    data() {
        return {
            loading:false,
            activeName: "1",
            tabList: [
                { name: "1", label: "系统管理员" },
                { name: "2", label: "成员权限" },
            ],
            tableData:[],
            tableDataAdmin:[],
            defaultImg: require("@/assets/images/default.jpg"),
            tableCustomConfig: {
                storage:true,
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return true;
                },
                checkMethod: (col) => {
                    return col.column.field !== "id";
                },
                allowSort: true,
            },
            addModuleDialog:false,
            keywords:'',
            moduleList:[
                {id:1,type:'customer',title:'CRM权限',label:'CRM管理员'},
                {id:2,type:'stock',title:'库存系统',label:'库存管理员'},
                {id:3,type:'project',title:'项目管理',label:'项目管理员'},
                {id:4,type:'finance',title:'财务管理',label:'财务管理员'},
                {id:5,type:'person',title:'人事管理',label:'人事管理员'},
                {id:6,type:'ticket_appmini',title:'票务小程序',label:'票务小程序管理员'},
                {id:7,type:'approval',title:'审批',label:'审批管理员'},

            ],
            moduleName:'',
            moduleAdminUser:'', //模块主管理员
            is_company_admin:false,// 是否为系统管理员
            is_system_sub_admin:false, // 是否为系统子管理员

            authorizedOperatorVisible:false,
            roleId:0,

            userDepartmentPostVisible:false,
            userDepartmentPostSelected:[],

        };
    },
    mixins: [pagination],
    computed: {
        ...mapState(["userInfo"]),
        reduceHeight() {
            return  (this.activeName == 1 && this.tableDataAdmin.length) || (this.activeName == 2 &&  this.tableData.length) ? 221 : 165;
        },
    },
    created() {
        this.moduleName = this.$route.query.type
        this.permissionFunction()
    },
    mounted() {
        this.getTableData()
    },
    methods: {
        // 判断是否是管理员，模块管理员，是否能设置权限
        permissionFunction(){
            let type = this.$route.query.type
            if(!type){
                this.$router.go(-1);
            }
            let is_company_admin = this.userInfo.user.is_company_admin // 是否为系统管理员
            let is_system_sub_admin = this.userInfo.user.is_system_sub_admin // 是否为系统子管理员
            let is_module_admin = this.userInfo.user.is_module_admin // 是否为模块管理员
            let have_modules = this.userInfo.user.have_modules // 模块管理员所拥有的模块
            this.is_company_admin = is_company_admin
            this.is_system_sub_admin = is_system_sub_admin
            if(!is_company_admin && !is_system_sub_admin && have_modules.indexOf(type) < 0){
                this.$router.go(-1);
            }else{
                let info = this.moduleList.find(find => find.type == type)
                this.$route.meta.title = info.title
                this.tabList[0].label = info.label ? info.label : '模块管理员'
            }
        },

        handleClickSearch(){
            this.pagination.pageNum = 1
            this.getTableData()
        },
        handleClickTab(item) {
            this.activeName = item.name;
            this.pagination.pageNum = 1
            this.getTableData()
        },
        // 表头配置
        handleClickCustom() {
            if(this.activeName == 1){
                this.$refs.tableRef.handleOpenCustomShow();
            }else{
                this.$refs.tableRef1.handleOpenCustomShow();
            }

        },
        handleSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val.pageSize
            this.getTableData()
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val
            this.getTableData()
        },
        getTableData() {
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                module_name:this.moduleName
            }
            this.loading = true
            if(this.activeName ==  1){
                getSubModuleAdmins(postData).then(res=> {
                    if(res.code === 200) {
                        let {data,total} = res.data
                        this.tableDataAdmin = data
                        this.pagination.total = total
                        if(data && data.length>0 && data[0].type == 0){
                            this.moduleAdminUser = data[0].user.name
                        }else{
                            this.moduleAdminUser = ''
                        }
                    }
                    this.loading = false
                })
            }else{
                postData.keyword = this.keywords
                getVirtualRoleListByModel(postData).then(res=> {
                    if(res.code === 200) {
                        let {data,total} = res.data
                        this.tableData = data
                        this.pagination.total = total
                    }
                    this.loading = false
                })
            }

        },
        // 添加模块管理员
        handleClickAddModule(){
            this.addModuleDialog = true
        },
        // 移除模块管理员
        handleClickModuleDel(row){
            const h = this.$createElement;
            this.$msgbox({
                title: '确定要移除该人员吗？',
                message: h('div', null, [
                    h('span', null, '移除后，该人员将无法管理该模块，模块内功能可能也无法使用！'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                customClass: 'prompt_message_custom',
                confirmButtonText: '移除',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass: 'el-button--danger danger',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {

                this.loading = true
                if(row.type == 0){
                    let postData = {
                        module_admin_id : row.id
                    }
                    deleteModuleAdmin(postData).then(res=> {
                        if(res.code === 200) {
                            this.$message.success('移除成功')
                            this.getTableData()
                        }
                        this.loading = false
                    })
                }else{
                    let postData = {
                        sub_admin_id : row.id
                    }
                    deleteSubModuleAdmin(postData).then(res=> {
                        if(res.code === 200) {
                            this.$message.success('移除成功')
                            this.getTableData()
                        }
                        this.loading = false
                    })
                }

            }).catch(() => {

            })
        },
        // 新增权限
        handleClickAddAuth(){
            this.roleId = 0
            this.authorizedOperatorVisible = true
        },
        // 授权人员
        handleClickAuth(row){
            this.roleId = row.role_id
            this.userDepartmentPostSelected = row.relations.map((item)=>{
                return {
                    relate_id: item.relation_id,
                    relate_name: item.relation_name,
                    relate_type: item.relation_type,
                    relate_type_id: item.relation_id + '_' +item.relation_type,
                }
            })
            this.userDepartmentPostVisible = true
        },
        // 编辑权限
        handleClickEditAuth(row){
            this.roleId = row.role_id
            this.authorizedOperatorVisible = true
        },
        // 删除权限
        handleClickDelAuth(row){
            const h = this.$createElement;
            this.$msgbox({
                title: '确定要删除该权限吗？',
                message: h('div', null, [
                    h('span', null, '删除后，该权限的授权人员也将被删除，可能无法使用相关功能！'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                customClass: 'prompt_message_custom',
                confirmButtonText: '删除',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass: 'el-button--danger danger',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                this.loading = true
                let postData = {
                    role_id : row.role_id
                }
                deleteVirtualRole(postData).then(res=> {
                    if(res.code === 200) {
                        this.$message.success('删除成功')
                        this.getTableData()
                    }
                    this.loading = false
                })
            }).catch(() => {

            })
        },
        // 授权人员回调
        userDepartmentPostSuccess(data){
            if(this.roleId){
                let postData = {
                    relations: data,
                    role_id : this.roleId,
                    update_type:'relation' //【列表使用，只更新授权人员】
                }
                updateUserPermissions(postData).then(res=> {
                    if(res.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '授权成功',
                            duration: 1500,
                            onClose: () => {}
                        })
                        this.getTableData()
                    }else{

                    }
                })
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/permission.scss";
</style>
